import { Link } from "react-router-dom";
import { ArrowRight, Siren, CalendarCheck } from "lucide-react";
import { Reveal, Eyebrow } from "../Reveal";
import { IMAGES } from "../../lib/data";

const Emergency = () => (
  <section data-testid="emergency-section" className="relative isolate overflow-hidden border-t border-black/10">
    <div className="absolute inset-0 -z-10">
      <img
        src={IMAGES.hero.url}
        alt=""
        aria-hidden="true"
        loading="lazy"
        className="h-full w-full object-cover opacity-15"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-ink via-ink/85 to-ink" />
    </div>

    <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-32">
      <Reveal>
        <Eyebrow>Emergency &amp; Preventive Maintenance</Eyebrow>
        <h2 className="max-w-3xl font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl lg:text-5xl">
          When Something Goes Wrong, You Need a Contractor Who Responds.
        </h2>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-mist md:text-lg">
          Petroleum retail properties operate every day, and unexpected facility problems can
          affect customers, employees and business operations. Petroline Services provides
          responsive maintenance support for qualifying commercial issues.
        </p>
      </Reveal>

      <div className="mt-14 grid gap-6 lg:grid-cols-2">
        <Reveal className="h-full">
          <div
            data-testid="emergency-response-card"
            className="flex h-full flex-col border border-ember/40 bg-white/90 p-8 backdrop-blur-sm lg:p-10"
          >
            <Siren className="h-8 w-8 text-ember" />
            <h3 className="mt-6 font-display text-xl font-bold tracking-tight md:text-2xl">
              Emergency Maintenance
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-mist md:text-base">
              Urgent facility issues need prompt attention. We work to minimize disruption so
              your site can keep serving customers while problems are addressed properly.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.12} className="h-full">
          <div
            data-testid="preventive-maintenance-card"
            className="flex h-full flex-col border border-black/10 bg-white/90 p-8 backdrop-blur-sm lg:p-10"
          >
            <CalendarCheck className="h-8 w-8 text-ember" />
            <h3 className="mt-6 font-display text-xl font-bold tracking-tight md:text-2xl">
              Preventive Maintenance
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-mist md:text-base">
              Planned maintenance helps operators identify deterioration, address smaller issues
              early and maintain the overall condition of their facilities — before small
              problems become operational ones.
            </p>
          </div>
        </Reveal>
      </div>

      <Reveal className="mt-12">
        <Link
          to="/contact"
          data-testid="emergency-cta-link"
          className="group inline-flex items-center gap-3 bg-ember px-8 py-4 font-display text-sm font-bold uppercase tracking-wider text-coal transition-transform duration-200 hover:-translate-y-0.5"
        >
          Discuss Your Maintenance Needs
          <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
        </Link>
      </Reveal>
    </div>
  </section>
);

export default Emergency;
